module.exports = __webpack_public_path__ + "img/home-new1.db517253.png";